import { render, staticRenderFns } from "./WdcCampaignChannelDesignList.vue?vue&type=template&id=f3d3503c&"
import script from "./WdcCampaignChannelDesignList.vue?vue&type=script&lang=js&"
export * from "./WdcCampaignChannelDesignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports